import React, { useCallback, useEffect } from "react";

import { isEmpty } from "lodash";
import { useWatch } from "react-hook-form-7";

import useStore from "../../../../store";

import { QuestionProps } from "./types/QuestionProps";

const ProgressNotifier: React.FC<QuestionProps> = ({
  question,
  control,
  path,
}) => {
  const setQuestionFilledState = useStore(
    useCallback((state) => state.report.setQuestionFilledState, [])
  );
  const [fieldValue, fieldTimeSpentValue] = useWatch({
    name: [`${path}.value`, `${path}.timeSpent`],
    control,
  });

  // Ensure that a question is not considered as done if it require the viewer to set a timeSpent
  const timeSpentBlocked = question.timeTracked && isEmpty(fieldTimeSpentValue);

  useEffect(
    () =>
      setQuestionFilledState(
        question.id,
        !isEmpty(fieldValue) && !timeSpentBlocked
      ),
    [fieldValue, timeSpentBlocked, question]
  );

  return null;
};

export default React.memo(ProgressNotifier);
